export default class APIError extends Error {}
